import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { cloneDeep, isEmpty, set } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DropdownCard from './DropdownCard';
import TextCard from './TextCard';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as action from '../Store/SystemMasters.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function CustomAttrSave(isCustomAttr, t) {
  return isCustomAttr ? (
    <Spinner animation="border" />
  ) : (
    <>
      <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_IDENTIFIER.SAVE')}
    </>
  );
}

const labelTmpObj = {
  keyName: null,
  isLable: true,
  type: null,
  isActive: true,
  // isChecked: true,
  _id: '',
  isEmpty: false,
  isNew: true,
  productType: [],
};
const valueTmpObj = {
  keyName: null,
  isLable: false,
  type: null,
  lableId: null,
  isActive: true,
  // isChecked: true,
  _id: '',
  isEmpty: false,
  isNew: true,
  productType: [],
};

function DamAttributeMaster({ OpenReArrangeFunction, parentState, parentSetState, attName }) {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const { SystemMastersDetails, UserDetails } = reducer;
  const { damAttributeDropdownList, damAttributeTextList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;
  const [openList, setOpenList] = useState([]);
  const [isLoadingCustomAttr, setIsLoadingCustomAttr] = useState(false);
  const [showCustomAttr, setShowCustomAttr] = useState(false);
  const [isCustomAttrUnique, setIsCustomAttrUnique] = useState(true);
  const [buttonDownCustomAttr, setButtonDownCustomAttr] = useState(true);
  const [CustomAttrBtnDisable, setCustomAttrBtnDisable] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isCustomAttr, setIsCustomAttr] = useState(false);
  const [isUniqCustomAttrId, setIsUniqCustomAttrId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState();

  const [state, setState] = useState({
    dropDownList: [],
    textList: [],
    modifiedList: [],
  });

  const getDamAttributeList = async () => {
    await Promise.all([dispatch(action.getDamAttributeFreeText({ type: attName })), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
  };

  const callApi = async () => {
    setButtonDownCustomAttr(!buttonDownCustomAttr);
    setShowCustomAttr(buttonDownCustomAttr);
    if (isEmpty(state?.dropDownList) && attName === 'dropdown') {
      setIsLoadingCustomAttr(true);
      getDamAttributeList();
      setIsLoadingCustomAttr(false);
    }
    if (isEmpty(state?.textList) && attName === 'text') {
      setIsLoadingCustomAttr(true);
      getDamAttributeList();
      setIsLoadingCustomAttr(false);
    }
  };

  const handleValueChanged = (event, i, parentIndex) => {
    const valueText = [...state.modifiedList];
    valueText[parentIndex].options[i].keyName = event.target.value;
    setState((prevState) => ({
      ...prevState,
      modifiedList: valueText,
    }));
  };

  const handleChanged = (event, i) => {
    const freeTextDropdownData = [...state.modifiedList];
    freeTextDropdownData[i] = {
      ...freeTextDropdownData[i],
      keyName: event.target.value?.trimStart(),
      isEmpty: event.target.value === '',
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
    setIsCustomAttrUnique(true);
    setIsUniqCustomAttrId([]);
    const arr = [];
    const arrIndex = [];
    freeTextDropdownData.forEach((ele, ind) => {
      freeTextDropdownData.forEach((objs, index) => {
        if (ele.keyName === objs.keyName && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });

    if (!isEmpty(arr)) {
      setIsUniqCustomAttrId([...arrIndex]);
    }
    setIsCustomAttrUnique(isEmpty(arr));
    let disableCustomAttr = false;
    freeTextDropdownData.forEach((CustomAttrElement) => {
      if (isEmpty(CustomAttrElement?.keyName?.trim())) {
        disableCustomAttr = true;
      }
    });
    setCustomAttrBtnDisable(disableCustomAttr);
  };

  const handleDelete = (id, parentI) => {
    if (typeof id === 'number' || id === '') {
      if (typeof parentI === 'number') {
        state.modifiedList[parentI].options.splice(id, 1);
      } else {
        state.modifiedList.splice(id, 1);
      }

      state.modifiedList.forEach((CustomAttrElement) => {
        if (isEmpty(CustomAttrElement?.keyName?.trim()) && CustomAttrElement.isNew) {
          setCustomAttrBtnDisable(true);
        } else {
          setCustomAttrBtnDisable(false);
        }
      });
      setIsCustomAttrUnique(true);
      setIsUniqCustomAttrId([]);

      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList],
      }));
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);

    const customAttributePara = {
      loggedInUserId,
      damAttributeId: deleteId,
      title: 'dam-attribute-master/delete',
    };

    setIsLoadingConf(false);
    setShowConfirmation(false);
    await dispatch(action.deleteFromSystemMasters(customAttributePara, t));
    await dispatch(action.getDamAttributeFreeText({ type: 'dropdown' }));
    await dispatch(action.getDamAttributeFreeText({ type: 'text' }));
  };

  const allData = [];
  const saveFreeTextDropdown = async () => {
    state.modifiedList?.forEach((ele) => {
      allData.push(ele);

      ele?.options?.forEach((eleChild) => {
        allData.push(eleChild);
      });
    });

    setIsCustomAttr(true);
    if (!isEmpty(allData)) {
      const emptyField = allData.filter(
        (custAttrItem) => custAttrItem.keyName === null || custAttrItem.keyName === '' || custAttrItem.keyName.trim() === '',
        // || ((!custAttrItem?.productType || custAttrItem?.productType?.length === 0) && !custAttrItem.lableId),
      );
      if (isEmpty(emptyField)) {
        const data = allData.map((nameObj) => {
          return { ...nameObj, name: nameObj.keyName.trim() };
        });
        const updatedData = data?.map((e) => {
          if (e.lableId) {
            delete e.productType;
          }
          return e;
        });
        const custAttrParams = {
          keyNames: JSON.stringify(updatedData),
          title: 'dam-attribute-master/add-update',
        };
        await dispatch(action.saveToSystemMaster(custAttrParams, t));
        getDamAttributeList();
      } else {
        const newState = state.modifiedList.map((item) => (item.keyName === null || item.productType?.length === 0 ? { ...item, isEmpty: true } : item));
        setState((prevState) => ({
          ...prevState,
          modifiedList: newState,
        }));
      }
    }
    setIsCustomAttr(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c3 = {};
    state.modifiedList.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: 'dam-attribute-master/active-inactive',
        };
        c3 = data;
      } else if (ele?.options?.length > 0) {
        const valueEle = ele.options.find((eleValue) => eleValue._id === activeInactiveID);
        if (valueEle) {
          valueEle.isActive = !valueEle.isActive;
          const dataValue = {
            ...valueEle,
            loggedInUserId,
            title: 'dam-attribute-master/active-inactive',
          };
          c3 = dataValue;
        }
      }
    });
    await dispatch(action.setActiveInactive(c3, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);

    setState((prevState) => ({
      ...prevState,
      modifiedList: [...state.modifiedList],
    }));
  };

  const addValueForLabel = (id, index) => {
    if (state?.modifiedList && state?.modifiedList?.find((list) => list?._id === id)?.options?.length > 19) {
      toasterMsg('Maximum 20 Entry Allowed.', 'danger');
    } else {
      const tempObj = cloneDeep(valueTmpObj);
      tempObj.lableId = id;
      tempObj.type = 'dropdown';

      const freeTextDropdownData = [...state.modifiedList];

      const existingValue = freeTextDropdownData[index].options;
      if (existingValue) {
        existingValue.push(tempObj);
      }

      freeTextDropdownData[index] = {
        ...freeTextDropdownData[index],
        options: existingValue || [tempObj],
      };

      setState((prevState) => ({
        ...prevState,
        modifiedList: freeTextDropdownData,
      }));
    }
  };

  const addCustomAttr = async () => {
    if (buttonDownCustomAttr) {
      callApi();
    }
    if (state.modifiedList && state.modifiedList.length > 9) {
      toasterMsg('Maximum 10 Entry Allowed.', 'danger');
    } else if (attName !== null) {
      const tempObj = cloneDeep(labelTmpObj);
      if (attName === 'text') {
        const objs = {
          textFieldConfig: {
            charLimit: 30,
          },
        };
        tempObj.isLable = false;
        tempObj.textFieldConfig = objs?.textFieldConfig;
      }
      tempObj.type = attName;
      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList, tempObj],
      }));
    }
  };

  const btnCall = () => {
    if (buttonDownCustomAttr === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const setModifiedData = (value, allTypeData) => {
    let filteredData = null;
    if (value === 'dropdown') {
      filteredData = allTypeData?.filter((element) => element?.isLable === true && element?.type === 'dropdown');
    } else if (value === 'text') {
      filteredData = allTypeData?.filter((element) => element?.type === 'text');
      filteredData = filteredData?.map((data) => {
        if (data?.textFieldConfig && data?.textFieldConfig?.charLimit <= 0) {
          data.textFieldConfig.charLimit = 30;
        }
        return data;
      });
    }

    if (!isEmpty(filteredData)) {
      filteredData.forEach((item, i) => {
        const valuesForLabel = allTypeData.filter((ele) => item._id === ele.lableId);
        filteredData[i].values = valuesForLabel;
      });
      setState((prevState) => ({
        ...prevState,
        modifiedList: filteredData,
      }));
    }
  };

  const handleTypeChange = (value) => {
    const newData = [...(state.dropDownList ?? []), ...(state.textList ?? [])];
    const allTypeData = cloneDeep(newData);
    if (CustomAttrBtnDisable) {
      setCustomAttrBtnDisable(false);
    }
    setState((prevState) => ({
      ...prevState,
      modifiedList: [],
      isUniqCustomAttrId: [],
    }));
    setModifiedData(value, allTypeData);
  };

  useEffect(() => {
    handleTypeChange(attName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attName]);

  const renderTooltipOpenCloseCustomAttr = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownCustomAttr ? 'Close' : 'Open'}
    </Tooltip>
  );
  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Active/inactive
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Delete
    </Tooltip>
  );
  const renderTooltipAddOption = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Add option
    </Tooltip>
  );

  const renderTooltipAddValue = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Add Value
    </Tooltip>
  );

  const renderTooltipReArrange = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Rearrange
    </Tooltip>
  );

  const renderTooltipEdit = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );

  const renderDropdownCard = (card, index) => {
    return (
      <DropdownCard
        key={card?.id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        renderTooltipAddValue={renderTooltipAddValue}
        addValueForLabel={addValueForLabel}
        handleValueChanged={handleValueChanged}
        renderTooltipActiveInactive={renderTooltipActiveInactive}
        activeInactiveClicked={activeInactiveClicked}
        renderTooltipDelete={renderTooltipDelete}
        renderTooltipAddOption={renderTooltipAddOption}
        handleDelete={handleDelete}
        isUniqueId={isUniqCustomAttrId}
        openList={openList}
        setOpenList={setOpenList}
      />
    );
  };

  const onChange = (value, i, path) => {
    const charLimit = parseInt(value, 10);
    if (path === 'textFieldConfig.charLimit' && charLimit > 30) {
      return;
    }
    const freeTextDropdownData = [...state.modifiedList];
    set(freeTextDropdownData[i], path, value);
    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
  };

  const renderTextCard = (card, index) => {
    return (
      <TextCard
        key={card?.id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        renderTooltipActiveInactive={renderTooltipActiveInactive}
        activeInactiveClicked={activeInactiveClicked}
        renderTooltipEdit={renderTooltipEdit}
        renderTooltipDelete={renderTooltipDelete}
        handleDelete={handleDelete}
        isUniqueId={isUniqCustomAttrId}
        onChange={onChange}
      />
    );
  };

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      dropDownList: damAttributeDropdownList,
    }));
  }, [damAttributeDropdownList]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      textList: damAttributeTextList,
    }));
  }, [damAttributeTextList]);

  useEffect(() => {
    if (attName === 'dropdown' || isEmpty(attName) || parentState?.rearrangeModal === 'damDropdownAttribute') {
      const filteredData = damAttributeDropdownList
        ?.filter((element) => element?.isLable === true && element?.type === 'dropdown')
        .map((data) => ({ name: data?.keyName, _id: data?._id }));
      parentSetState((prevState) => ({
        ...prevState,
        rearrangeData: filteredData,
      }));
    } else {
      const textFilteredData = damAttributeTextList
        ?.filter((element) => element?.isLable === false && element?.type === 'text')
        .map((data) => ({ name: data?.keyName, _id: data?._id }));
      parentSetState((prevState) => ({
        ...prevState,
        rearrangeData: textFilteredData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [damAttributeDropdownList, damAttributeTextList, parentState?.rearrangeModal, attName]);

  useEffect(() => {
    if (isEmpty(attName)) {
      handleTypeChange('dropdown');
    } else {
      handleTypeChange(attName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.dropDownList, state?.textList]);

  console.log('state.modifiedList', state.modifiedList);

  return (
    <>
      <Accordion className="mb-4 master-accordian dam-attribute-master">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{attName === 'dropdown' ? 'Custom Dropdown' : 'Custom Textbox'}</p>
            </div>
            <div className="action-title-btns">
              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipReArrange}>
                <button
                  type="button"
                  onClick={() => OpenReArrangeFunction(attName === 'dropdown' ? 'damDropdownAttribute' : 'damTextAttribute')}
                  className="filter-btn filter-button_add"
                  disabled={CustomAttrBtnDisable || !isCustomAttrUnique}
                  aria-label="Rearrange"
                >
                  <span className="icon-expand" />
                </button>
              </OverlayTrigger>

              <BtnAdd onBtnClick={addCustomAttr} forDisable={CustomAttrBtnDisable || !isCustomAttrUnique} addEditAccess />

              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenCloseCustomAttr}>
                <button onClick={() => callApi()} type="button">
                  {btnCall()}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showCustomAttr &&
            (isLoadingCustomAttr ? (
              <Loader />
            ) : (
              <Card.Body>
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  {Array.isArray(state?.modifiedList) &&
                    !isEmpty(state?.modifiedList) &&
                    state?.modifiedList?.map((ele, index) => {
                      return ele?.type === 'dropdown' ? renderDropdownCard(ele, index) : renderTextCard(ele, index);
                    })}
                </PerfectScrollbar>
                <div className="section-save">
                  <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                    <button
                      aria-label="Save"
                      type="button"
                      className="btn btn-page-filter btn-white ml-0"
                      onClick={saveFreeTextDropdown}
                      disabled={CustomAttrBtnDisable || !isCustomAttrUnique}
                    >
                      {CustomAttrSave(isCustomAttr, t)}
                    </button>
                  </CustomTooltip>
                </div>
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title="Delete From System Master"
          message="Are you sure you want to delete this item?"
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title="Activate/Deactivate"
          message="Are you sure you want to Activate/Deactivate this item?"
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default DamAttributeMaster;
